import newGuid from '@/helpers/guid/newGuid';

export default () => btoa(newGuid().replace(/-/g, '')).slice(0, 14);
